import { render } from "./FrameFormDesigner.vue?vue&type=template&id=62a11356&scoped=true"
import script from "./FrameFormDesigner.vue?vue&type=script&lang=js"
export * from "./FrameFormDesigner.vue?vue&type=script&lang=js"

import "./FrameFormDesigner.vue?vue&type=style&index=0&id=62a11356&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a11356"]])

export default __exports__